var Afghanistan = "アフガニスタン";
var Albania = "アルバニア";
var Algeria = "アルジェリア";
var Andorra = "アンドラ";
var Angola = "アンゴラ";
var Anguilla = "アングイラ島";
var Antarctica = "南極";
var Argentina = "アルゼンチン";
var Armenia = "アルメニア";
var Aruba = "アルーバ";
var Australia = "オーストラリア";
var Austria = "オーストリア";
var Azerbaijan = "アゼルバイジャン";
var Bahamas = "バハマ諸島";
var Bahrain = "バーレーン";
var Bangladesh = "バングラデシュ";
var Barbados = "バルバドス";
var Belarus = "ベラルーシ";
var Belgium = "ベルギー";
var Belize = "ベリーズ";
var Benin = "ベナン";
var Bermuda = "バミューダ";
var Bhutan = "ブータン";
var Bolivia = "ボリビア";
var Botswana = "ボツワナ";
var Brazil = "ブラジル";
var Bulgaria = "ブルガリア";
var Burundi = "ブルンジ";
var Cambodia = "カンボジア";
var Cameroon = "カメルーン";
var Canada = "カナダ";
var Chad = "チャド";
var Chile = "チリ";
var China = "中国";
var Colombia = "コロンビア";
var Comoros = "コモロ";
var Congo = "コンゴ";
var Croatia = "クロアチア";
var Cuba = "キューバ";
var Cyprus = "キプロス";
var Denmark = "デンマーク";
var Djibouti = "ジブチ";
var Dominica = "ドミニカ";
var Ecuador = "エクアドル";
var Egypt = "エジプト";
var Eritrea = "エリトリア";
var Estonia = "エストニア";
var Ethiopia = "エチオピア";
var Fiji = "フィジー";
var Finland = "フィンランド";
var France = "フランス";
var Gabon = "ガボン";
var Gambia = "ガンビア";
var Georgia = "ジョージア";
var Germany = "ドイツ";
var Ghana = "ガーナ";
var Gibraltar = "ジブラルタル";
var Greece = "ギリシャ";
var Greenland = "グリーンランド";
var Grenada = "グレナダ";
var Guadeloupe = "グアドループ";
var Guam = "グアム島";
var Guatemala = "グアテマラ";
var Guernsey = "ガーンジー島";
var Guinea = "ギニア";
var Guyana = "ガイアナ";
var Haiti = "ハイチ";
var Honduras = "ホンジュラス";
var Hungary = "ハンガリー";
var Iceland = "アイスランド";
var India = "インド";
var Indonesia = "インドネシア";
var Iraq = "イラク";
var Ireland = "アイルランド";
var Israel = "イスラエル";
var Italy = "イタリア";
var Jamaica = "ジャマイカ";
var Japan = "日本";
var Jersey = "ジャージー";
var Jordan = "ヨルダン";
var Kazakhstan = "カザフスタン";
var Kenya = "ケニア";
var Kiribati = "キリバス";
var Kuwait = "クウェート";
var Kyrgyzstan = "キルギスタン";
var Latvia = "ラトビア";
var Lebanon = "レバノン";
var Lesotho = "レソト";
var Liberia = "リベリア";
var Libya = "リビア・アラブ・ジャマーヒリーヤ";
var Liechtenstein = "リヒテンシュタイン";
var Lithuania = "リトアニア";
var Luxembourg = "ルクセンブルグ";
var Macao = "マカオ";
var Madagascar = "マダガスカル";
var Malawi = "マラウイ";
var Malaysia = "マレーシア";
var Maldives = "モルディブ";
var Mali = "マリ";
var Malta = "マルタ";
var Martinique = "マルティニーク";
var Mauritania = "モーリタニア";
var Mauritius = "モーリシャス";
var Mayotte = "マヨット";
var Mexico = "メキシコ";
var Monaco = "モナコ";
var Mongolia = "モンゴル";
var Montenegro = "モンテネグロ";
var Montserrat = "モンセラット";
var Morocco = "モロッコ";
var Mozambique = "モザンビーク";
var Myanmar = "ミャンマー";
var Namibia = "ナミビア";
var Nauru = "ナウル";
var Nepal = "ネパール";
var Netherlands = "オランダ";
var Nicaragua = "ニカラグア";
var Niger = "ニジェール";
var Nigeria = "ナイジェリア";
var Niue = "ニウエ";
var Norway = "ノルウェー";
var Oman = "オマーン";
var Pakistan = "パキスタン";
var Palau = "パラオ";
var Panama = "パナマ";
var Paraguay = "パラグアイ";
var Peru = "ペルー";
var Philippines = "フィリピン";
var Pitcairn = "ピトケアン諸島";
var Poland = "ポーランド";
var Portugal = "ポルトガル";
var Qatar = "カタール";
var Romania = "ルーマニア";
var Rwanda = "ルワンダ";
var Samoa = "サモア";
var Senegal = "セネガル";
var Serbia = "セルビア";
var Seychelles = "セーシェル";
var Singapore = "シンガポール";
var Slovakia = "スロバキア";
var Slovenia = "スロベニア";
var Somalia = "ソマリア";
var Spain = "スペイン";
var Sudan = "スーダン";
var Suriname = "スリナム";
var Swaziland = "エスワティニ";
var Sweden = "スウェーデン";
var Switzerland = "スイス";
var Taiwan = "台湾";
var Tajikistan = "タジキスタン";
var Thailand = "タイ";
var Togo = "トーゴ";
var Tokelau = "トケラウ";
var Tonga = "トンガ";
var Tunisia = "チュニジア";
var Turkey = "トルコ";
var Turkmenistan = "トルクメニスタン";
var Tuvalu = "ツバル";
var Uganda = "ウガンダ";
var Ukraine = "ウクライナ";
var Uruguay = "ウルグアイ";
var Uzbekistan = "ウズベキスタン";
var Vanuatu = "バヌアツ";
var Venezuela = "ベネズエラ";
var Yemen = "イエメン";
var Zambia = "ザンビア";
var Zimbabwe = "ジンバブエ";
var countries = {
	"Country or region": "国または地域",
	"United States": "米国",
	Afghanistan: Afghanistan,
	"Åland Islands": "オーランド諸島",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "アメリカ領サモア",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "アンティグア・バーブーダ",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "ボスニア・ヘルツェゴビナ",
	Botswana: Botswana,
	"Bouvet Island": "ブーヴェ島",
	Brazil: Brazil,
	"British Indian Ocean Territory": "イギリス領インド洋地域",
	"Brunei Darussalam": "ブルネイ・ダルサラーム",
	Bulgaria: Bulgaria,
	"Burkina Faso": "ブルキナファソ",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "カーボベルデ",
	"Cayman Islands": "ケイマン諸島",
	"Central African Republic": "中央アフリカ共和国",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "クリスマス島",
	"Cocos (Keeling) Islands": "ココス諸島",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "コンゴ民主共和国",
	"Cook Islands": "クック諸島",
	"Costa Rica": "コスタリカ",
	"Côte d'Ivoire": "コートジボワール",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "チェコ共和国",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "ドミニカ共和国",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "エルサルバドル",
	"Equatorial Guinea": "赤道ギニア",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "フォークランド諸島 (マルビナス諸島)",
	"Faroe Islands": "フェロー諸島",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "フランス領ギアナ",
	"French Polynesia": "フランス領ポリネシア",
	"French Southern Territories": "フランス領南方・南極地域",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "ギニアビサウ",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "ハード島とマクドナルド諸島",
	"Holy See (Vatican City State)": "ローマ教皇庁 (バチカン)",
	Honduras: Honduras,
	"Hong Kong": "香港",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "イラン・イスラム共和国",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "マン島",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "朝鮮民主主義人民共和国",
	"Korea, Republic of": "大韓民国",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "ラオス人民民主共和国",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "マケドニア旧ユーゴスラビア共和国",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "マーシャル諸島",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "ミクロネシア連邦",
	"Moldova, Republic of": "モルドバ共和国",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "オランダ領アンティル",
	"New Caledonia": "ニューカレドニア",
	"New Zealand": "ニュージーランド",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "ノーフォーク島",
	"Northern Mariana Islands": "北マリアナ諸島",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "パレスチナ自治区",
	Panama: Panama,
	"Papua New Guinea": "パプアニューギニア",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "プエルトリコ",
	Qatar: Qatar,
	"Réunion": "レユニオン",
	Romania: Romania,
	"Russian Federation": "ロシア連邦",
	Rwanda: Rwanda,
	"Saint Helena": "セントヘレナ",
	"Saint Kitts and Nevis": "セントクリストファー・ネイビス",
	"Saint Lucia": "セントルシア",
	"Saint Pierre and Miquelon": "サンピエール島・ミクロン島",
	"Saint Vincent and The Grenadines": "セントビンセントおよびグレナディーン諸島",
	Samoa: Samoa,
	"San Marino": "サンマリノ",
	"Sao Tome and Principe": "サントメ・プリンシペ",
	"Saudi Arabia": "サウジアラビア",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "シエラレオネ",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "ソロモン諸島",
	Somalia: Somalia,
	"South Africa": "南アフリカ",
	"South Georgia and The South Sandwich Islands": "サウスジョージア・サウスサンドウィッチ諸島",
	Spain: Spain,
	"Sri Lanka": "スリランカ",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "スヴァールバル諸島およびヤンマイエン島",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "シリア・アラブ共和国",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "タンザニア連合共和国",
	Thailand: Thailand,
	"Timor-Leste": "東ティモール",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "トリニダード・トバゴ",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "タークス・カイコス諸島",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "アラブ首長国連邦",
	"United Kingdom": "英国",
	"United States Minor Outlying Islands": "合衆国領有小離島",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "ベトナム",
	"Virgin Islands, British": "イギリス領バージン諸島",
	"Virgin Islands, U.S.": "アメリカ領バージン諸島",
	"Wallis and Futuna": "ウォリス・フツナ",
	"Western Sahara": "西サハラ",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
